export default class UserAttributeError extends Error {
    static get ATTRIBUTES() {
        return {
            ATTRIBUTE: 'Attribute',
            FIRST_NAME: 'First name',
            LAST_NAME: 'Last name',
            LINK: 'Link',
            EMAIL: 'Email address',
        };
    }
    static get FAILURES() {
        return {
            INVALID: 'is not valid',
            REQUIRED: 'is required',
            TAKEN: 'is already registered, please sign in',
            EXPIRED: 'has expired, please request another',
            INCORRECT: 'is not valid, please confirm and try again',
            UNCONFIRMED: 'must be confirmed before continuing, check your email inbox',
        };
    }
    attribute;
    failure;
    dpError;
    constructor(attribute = '', failure = UserAttributeError.FAILURES.INVALID) {
        const message = `${attribute} ${failure}`;
        super(message);
        this.attribute = attribute;
        this.failure = failure;
        this.dpError = true;
    }
}
